"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleCurrencyService = void 0;
const ShopPriceCountryMapper_1 = require("./ShopPriceCountryMapper");
class LocaleCurrencyService {
    static getLocaleCurrency(rawPriceCountry) {
        if (!rawPriceCountry) {
            return { code: 'EUR', symbol: '€' };
        }
        const priceCountry = ShopPriceCountryMapper_1.ShopPriceCountryMapper.toAlpha2CountryCode(rawPriceCountry);
        switch (priceCountry) {
            case 'AT':
            case 'BE':
            case 'DE':
            case 'DK':
            case 'ES':
            case 'FI':
            case 'FR':
            case 'HU':
            case 'IE':
            case 'IT':
            case 'LT':
            case 'NL':
            case 'PT':
            case 'SI':
            case 'SK':
            case 'TR':
            case 'UA':
                return { code: 'EUR', symbol: '€' };
            case 'AU':
                return { code: 'AUD', symbol: '$' };
            case 'BG':
                return { code: 'BGN', symbol: 'lv' };
            case 'BR':
                return { code: 'BRL', symbol: 'R$' };
            case 'BY':
                return { code: 'BYR', symbol: 'Br' };
            case 'CA':
            case 'MX':
            case 'US':
                return { code: 'USD', symbol: '$' };
            case 'CH':
                return { code: 'CHF', symbol: 'Fr.' };
            case 'CL':
                return { code: 'CLP', symbol: '$' };
            case 'CN':
                return { code: 'RMB', symbol: '¥' };
            case 'CZ':
                return { code: 'CZK', symbol: 'Kč' };
            case 'EG':
                return { code: 'EGP', symbol: '£' };
            case 'HR':
                return { code: 'HRK', symbol: 'kn' };
            case 'ID':
                return { code: 'IDR', symbol: 'Rp.' };
            case 'IL':
                return { code: 'ILS', symbol: '₪' };
            case 'IN':
                return { code: 'INR', symbol: '₹' };
            case 'JP':
                return { code: 'JPY', symbol: '¥' };
            case 'KR':
                return { code: 'WON', symbol: '₩' };
            case 'LB':
                return { code: 'LBP', symbol: 'ل.ل.' };
            case 'MY':
                return { code: 'MYR', symbol: 'RM' };
            case 'NO':
                return { code: 'NOK', symbol: 'kr' };
            case 'NZ':
                return { code: 'NZD', symbol: '$' };
            case 'PL':
                return { code: 'PLN', symbol: 'zł' };
            case 'RO':
                return { code: 'EUR', symbol: '€' };
            case 'RS':
                return { code: 'RSD', symbol: 'din' };
            case 'RU':
                return { code: 'RUB', symbol: '₽' };
            case 'SE':
                return { code: 'SEK', symbol: 'kr' };
            case 'SG':
                return { code: 'SGD', symbol: '$' };
            case 'TH':
                return { code: 'THB', symbol: '฿' };
            case 'TW':
                return { code: 'TWD', symbol: '元' };
            case 'GB':
                return { code: 'GBP', symbol: '£' };
            case 'VN':
                return { code: 'VND', symbol: '₫' };
            case 'ZA':
                return { code: 'ZAR', symbol: 'R' };
            case 'NG':
                return { code: 'NGN', symbol: '₦' };
            case 'TN':
                return { code: 'TUN', symbol: 'DT' };
            default:
                return { code: 'EUR', symbol: '€' };
        }
    }
}
exports.LocaleCurrencyService = LocaleCurrencyService;
//# sourceMappingURL=LocaleCurrencyService.js.map